import React from 'react'
import { StaticQuery, graphql } from "gatsby"
import { SimilarArticlesFactory } from './similarArticlesFactory'
import BlogCardWithImageAndDesc from '../cards/CardBlogWithImageAndDesc'

const SimilarArticlesComponent = ({ articles }) => (
    <div className="my-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
        {articles.map((item, i) => (
            <BlogCardWithImageAndDesc post={item} key={i} />
        ))}
    </div>
)

function getPostsFromQuery(posts) {
    if (posts) {
        return posts.edges
            .map(edge => edge.node)
            .map(node => Object.assign({}, node.frontmatter))
    }
    return []
}


// (1.) Query for articles
const similarArticle = (props) => (
    <StaticQuery query={graphql`
        query SimilarArticles {
            posts: allMarkdownRemark(
                sort: {frontmatter: {date: DESC}}
                filter: {frontmatter: {slug: {ne: null}, date: {ne: null}}}
            ) {
                totalCount
                edges {
                    node {
                        id
                        frontmatter {
                            slug
                            title
                            date(formatString: "MMMM DD, YYYY")
                            category: categories
                            description
                            keywords
                            excerpt
                        }
                    }
                }
            }
        }
    `}
        render={data => {
            const { category, keywords, currentArticleSlug } = props;

            // (2.) Marshall the response into articles
            const articles = getPostsFromQuery(data.posts);

            // (3.) Use a SimilarArticlesFactory to get my similar articles
            const similarArticles = new SimilarArticlesFactory(
                articles, currentArticleSlug
            )
                .setMaxArticles(2)
                .setCategory(category)
                .setKeywords(keywords)
                .getArticles();

            // (4.) Render it
            return (
                <SimilarArticlesComponent
                    articles={similarArticles}
                />
            )
        }}
    />
)

export default similarArticle;